import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { careers } from "../data/blog";

export default function CareerForm() {
  const [sent, setSent] = useState(false);
  return (
    <>
      <PageHeader
        title="Apply Now"
        crumbs={[{ label: "Careers", to: "/careers" }, { label: "Apply" }]}
      />
      <section className="section">
        <div className="container" style={{ maxWidth: 760 }}>
          {sent ? (
            <div className="card" style={{ padding: 50, textAlign: "center" }}>
              <div className="confirm-icon"><FaCheckCircle /></div>
              <h2>Application Submitted!</h2>
              <p className="sec-text mt-2">
                Thank you for applying to join Taxi24hrs. Our HR team will review
                your application and contact you soon.
              </p>
            </div>
          ) : (
            <>
              <SectionTitle
                subtitle="Job Application"
                title="Submit Your <span>Application</span>"
                text="Fill out the form below and take the first step towards your new career."
              />
              <form className="card" style={{ padding: 36 }} onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
                <div className="form-row">
                  <div className="field">
                    <label>First Name</label>
                    <input type="text" required />
                  </div>
                  <div className="field">
                    <label>Last Name</label>
                    <input type="text" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="field">
                    <label>Email</label>
                    <input type="email" required />
                  </div>
                  <div className="field">
                    <label>Phone</label>
                    <input type="tel" required />
                  </div>
                </div>
                <div className="field">
                  <label>Position</label>
                  <select>
                    {careers.map((c) => <option key={c.id}>{c.title}</option>)}
                  </select>
                </div>
                <div className="field">
                  <label>Years of Experience</label>
                  <input type="number" min="0" required />
                </div>
                <div className="field">
                  <label>Cover Letter</label>
                  <textarea placeholder="Tell us why you'd be a great fit" />
                </div>
                <div className="field">
                  <label>Upload Resume</label>
                  <input type="file" />
                </div>
                <button type="submit" className="btn btn-primary">Submit Application</button>
              </form>
            </>
          )}
        </div>
      </section>
    </>
  );
}
